'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var Footer = require('@narvar/nth-bundle-narvar-footer');
var OrderLookupHeroImage = require('./OrderLookupHeroImage.js');
var Header = require('../../../../common/components/layout/Header.js');
var reactRouterDom = require('react-router-dom');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var Footer__default = /*#__PURE__*/_interopDefaultLegacy(Footer);

const Container = styled__default["default"].div.withConfig({
  componentId: "sc-lve844-0"
})(["display:flex;flex-direction:column;height:100vh;"]);
const InnerContainer = styled__default["default"].div.withConfig({
  componentId: "sc-lve844-1"
})(["display:flex;flex-direction:row;flex:1 0 0;justify-content:center;"]);
const LeftPanel = styled__default["default"].div.withConfig({
  componentId: "sc-lve844-2"
})(["padding:2rem 2rem 0 2rem;display:flex;flex-direction:column;justify-content:space-between;flex:1 0 20rem;"]);
const OrderLookupDesktop = () => {
  // This is only to facilitate retailers who don't have an order lookup hero image yet. If there is no
  // image, we need to center the order lookup form. Since most retailers will have an image, we will
  // prefer keeping the form on the left side, and centering it if we have no image. We want to
  // avoid the form shifting from center to left once an order lookup hero image loads. We'll defer the
  // content shifting to the lesser case where there is no order lookup hero image to load.
  const [hasImage, setHasImage] = React.useState(true);
  const onImageLookupComplete = React.useCallback(_ref => {
    let {
      hasImage
    } = _ref;
    return setHasImage(hasImage);
  }, [setHasImage]);
  return /*#__PURE__*/React__default["default"].createElement(Container, null, /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(Header["default"], null)), /*#__PURE__*/React__default["default"].createElement(InnerContainer, null, /*#__PURE__*/React__default["default"].createElement(LeftPanel, null, /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      width: '100%',
      maxWidth: '20rem',
      margin: hasImage ? undefined : '0 auto'
    }
  }, /*#__PURE__*/React__default["default"].createElement(reactRouterDom.Outlet, null)), /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      width: '100%',
      maxWidth: '49.5rem',
      margin: '0 auto'
    }
  }, /*#__PURE__*/React__default["default"].createElement(Footer__default["default"], {
    hack_paddingOverride: "padding: 1rem 0 2rem 0"
  }))), /*#__PURE__*/React__default["default"].createElement(OrderLookupHeroImage["default"], {
    onImageLookupComplete: onImageLookupComplete
  })));
};

exports["default"] = OrderLookupDesktop;
